import { AxiosResponse } from "axios";
import { ActivityDto, CreateActivityDto, UpdateActivityDto, UpdateActivityStatusDto } from "../types/activityTypes";
import api from "../utils/api";

export const getAllActivities = async (): Promise<AxiosResponse<ActivityDto[]>> => {
  return await api.get<ActivityDto[]>("/activities");
};

export const getActivityById = async (activityId: number): Promise<AxiosResponse<ActivityDto>> => {
  return await api.get<ActivityDto>(`/activities/${activityId}`);
};

export const getActivitiesByContactPerson = async (contactPersonId: number): Promise<AxiosResponse<ActivityDto[]>> => {
  return await api.get<ActivityDto[]>(`/activities/contact-persons/${contactPersonId}`);
};

export const createActivity = async (data: CreateActivityDto): Promise<AxiosResponse<ActivityDto>> => {
  return await api.post<ActivityDto>("/activities", data);
};

export const updateActivity = async (
  activityId: number,
  data: UpdateActivityDto
): Promise<AxiosResponse<ActivityDto>> => {
  return await api.put<ActivityDto>(`/activities/${activityId}`, data);
};

export const updateActivityStatus = async (
  activityId: number,
  data: UpdateActivityStatusDto
): Promise<AxiosResponse<ActivityDto>> => {
  return await api.post<ActivityDto>(`/activities/${activityId}/update-status`, data);
};

export const deleteActivity = async (activityId: number): Promise<AxiosResponse<boolean>> => {
  return await api.delete<boolean>(`/activities/${activityId}`);
};
